import $ from 'jquery';
import {View} from 'backbone';
import { Model } from 'backbone';
import constants from 'Constants.js';
import _template from 'dashboard/reports/view-reports-dashboard.ejs';
import eventBus  from 'EventBus.js';
import RestService from 'RestService.js';
import SelectItemModalView  from 'common-views/SelectItemModalView.js';
import NotificationService from 'NotificationService.js';
import util from 'util/Util.js';

class ViewReportsDashboardView extends View {

    className(){
        return 'ViewReportsDashboardView';
    }

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;

        this.events = {
            'click #recentEdits > ul > li' : 'showReportDetails',
            'dblclick #favoriteForms > ul > li' : 'showReportDetails',
            'click ul.select-list li' : 'showReportsInfo',
            'click #addReport' : 'addFavorites', 
            'click #removeReport' : 'removeFavorites',
            'click #favoriteForms > ul > li' : 'selectFavoriteReport'
        };

        if (!opts.model.get('titleSection')) {
            this.model.set('titleSection', 'View Recent');
            this.model.set('type', 'view');

        }

        if(!this.model.get('dependenceList')){
            this.model.set('dependenceList', []);
        }
        if(!this.model.get('privateReports')){
            this.model.set('privateReports', []);
        }
        
        util.setDashboardReportsListCache();

        return this;
    }

    addFavorites(ev){
        ev.preventDefault();
        const _cachedItems = util.getDashboardReportsListCache();
        if (!_cachedItems) {
            let _self = this;
            RestService.searchReportByName('', true).then((results) => {

                let group = results.RESULT.RESPONSE.Group;
                let _items = [];

                if (group && group.Item) {
                    _items = group.Item instanceof Array ?
                    group.Item : [group.Item];
                }

                let items = _items.map((item) => {
                    return {
                        label: item['@name'],
                        listType: item['@id'],
                        items: item
                    }
                });

                util.setDashboardReportsListCache(items);
                _self.fillFavoritesModal(items);                 
            });
        } else {
            this.fillFavoritesModal(_cachedItems);
        }
    }

    fillFavoritesModal(items){
        let formsView = new SelectItemModalView({ model: new Model({ items: items, multipleSelectionEnabled: true }) });
        formsView.render().then(selectedItem => {
            if (selectedItem) {
                let _selectedItems = [];
                if (!$.isArray(selectedItem)) { //If more than one item is selected then will return an array
                    _selectedItems.push(selectedItem);
                } else {
                    _selectedItems = selectedItem;
                }
                let _self = this;
                let _params = { formIds: [] };
                let currentFavoritesList = _self.model.get('currentFavoritesList') || [];
                let formsChanged = [];

                $.each(_selectedItems, function (index, _selectedItem) {
                    // Checking if the permission selected is not already present in the current list.


                    if (currentFavoritesList) {
                        let formChanged = currentFavoritesList.filter((form) => {
                            return form['@id'] === _selectedItem.items['@id'];
                        });

                        if (formChanged.length) {
                            formsChanged.push(formChanged);
                        }
                        else {
                            currentFavoritesList.push(_selectedItem.items);
                            _params.formIds.push(_selectedItem.items['@id']);

                            _self.model.set('hasChanges', true, { silent: true });
                        }
                    }
                });

                currentFavoritesList.sort(function (a, b) {
                    var aName = a['@name'].toLowerCase();
                    var bName = b['@name'].toLowerCase();
                    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
                });

                _self.model.set('currentFavoritesList', currentFavoritesList, { silent: true });

                if (_params.formIds.length) {
                    RestService.
                        addFavorites(_params, 2)
                        .then(result => {
                            _self.render();
                        });
                }
                else {
                    _self.render();
                }
            }
        }).catch((errMsg) => {
            console.log(errMsg);
            notificationService.error(errMsg);
        });
    }

    removeFavorites(ev) {
        ev.preventDefault();

        let currentFavoritesList = this.model.get('currentFavoritesList');
        if (this.favoriteSelected && currentFavoritesList && currentFavoritesList.length > 0) {
            let _params = {
                formId: this.favoriteSelected
            }

            let _self = this;

            RestService
                .removeFavorites(_params, 2)
                .then(result => {
                    let selectedElementIdx = 0;
                    let nextElementIdx = 0;

                    $.each(currentFavoritesList, (idx, item) => {
                        if (item['@id'] === _self.favoriteSelected) {
                            selectedElementIdx = idx;
                            return;
                        }
                    });

                    if (selectedElementIdx === currentFavoritesList.length - 1) {
                        nextElementIdx = selectedElementIdx - 1;
                    } else {
                        nextElementIdx = selectedElementIdx;
                    }

                    currentFavoritesList = currentFavoritesList.filter(f => f['@id'] !== _self.favoriteSelected);
                    _self.model.set('currentFavoritesList', currentFavoritesList, { silent: true });

                    if (nextElementIdx >= 0) {
                        let _scrollTop = $("#favoriteForms").parent().scrollTop();
                        _self.favoriteSelected = currentFavoritesList[nextElementIdx]['@id'];
                        _self.render();

                        let nextElement = $('#favoriteForms ul li')[nextElementIdx];
                        $(nextElement).addClass('dashboard-favorited-item');
                        $("#favoriteForms").parent().scrollTop(_scrollTop);
                    } else {
                        _self.favoriteSelected = null;
                        _self.render();
                        $('#removeReport').prop('disabled', false);
                    }
                }).catch(result => {
                    $('#removeReport').prop('disabled', false);
                });
        } 
    }

    selectFavoriteReport(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        let favorited = $('.dashboard-favorited-item');
        if (favorited) {
            favorited.removeClass('dashboard-favorited-item')
        }

        $(ev.currentTarget).addClass('dashboard-favorited-item');

        const formId = ev.currentTarget.attributes["data-id"].value;
        this.favoriteSelected = formId; 
    }
     
    showReportDetails(ev) {
        const reportId = ev.currentTarget.attributes["data-id"].value;
        const isPrivate = util.isTrue(ev.currentTarget.attributes["data-isprivate"].value );
        eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId, undefined, undefined, undefined, isPrivate);
    }

    showReportsInfo(ev) {

        ev.preventDefault();
        ev.stopPropagation();

        const reportId = ev.currentTarget.attributes["data-id"].value;
        const text = ev.target.innerHTML;

        if (reportId === 'all' || reportId === 'none'){
            return;
        }

        this.model.get('privateReports').map( ( r ) => {
            if ( r['@id'] === reportId) {
                r['@class'] = 'selected';
            }else{
                r['@class'] = '';
            }
        });
        
        let dependenceList = [];

        RestService.getReportDetails(reportId).then((reportDetailsResult) => {

            const reportDetailsData = reportDetailsResult.RESULT.RESPONSE.PrivateReportDetails;

            if (reportDetailsData['Dependencies']) {
                let tmpDependenceList = reportDetailsData['Dependencies'].Dependency instanceof Array
                    ? reportDetailsData['Dependencies'].Dependency
                    : [reportDetailsData['Dependencies'].Dependency];
                dependenceList = _.sortBy(tmpDependenceList,['@type', '@name']);
            }

            this.model.set('dependenceList', Object.assign([],dependenceList), {silent:true});
            this.render();

            $('#dropdownMenu1').text(text);

        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    render() {
        this.$el.html(this.template(this.model.toJSON()));
        this.delegateEvents();
        return this;
    }

    refresh(){
        eventBus.trigger(constants.EV_REFRESH_REPORT_MAIN_VIEW_DETAILS)
    }

}

export default ViewReportsDashboardView;